//
// Module for the Seminars index page
//
rs.module("content/seminarattendance/edit",

    [
        "common/select-helper"
    ],

    function (selectHelper) {

        function initialize(jsSelectors, searchControl, ajaxUrl) {
            var form = $.js(jsSelectors.form);
            var representativeSelect = form.js(jsSelectors.representativeSelect, { required: false });
            var representativeSelectHelper = selectHelper.getHelper(representativeSelect, { required: false });

            if (searchControl) {
                // Listen for a person to be selected from the search control
                searchControl.onSelectionComplete(function (employerKey) {

                    $.getJSON(
                        ajaxUrl,
                        { employerKey: employerKey }
                    ).done(function (data) {
                        representativeSelectHelper.replaceOptions(data, { withBlank: true });
                    });
                });

                // Listen for search selection to be removed
                searchControl.onSelectionCleared(function () {
                    representativeSelectHelper.setValue(null);
                    representativeSelectHelper.clearOptions();
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);